import React from 'react'
import { CSSTransition } from 'react-transition-group'

export default function Modal({ show, setModal, sm, lg, style, className, title, warning, hdrActn, children, subTitle }) {
  const handleClickOutside = e => {
    if (e.target.classList.contains('btcd-modal-wrp')) {
      setModal(false)
    }
  }


  return (
    <CSSTransition
      in={show}
      timeout={500}
      classNames="btc-mdl-trn"
      unmountOnExit
    >
      <div
        role="button"
        tabIndex={0}
        onKeyPress={handleClickOutside}
        onClick={handleClickOutside}
        className="btcd-modal-wrp flx"
      >
        <div
          className={`btcd-modal ${sm ? 'btcd-m-sm' : ''} ${lg ? 'btcd-m-lg' : ''} ${className}`}
          style={style}
        >
          <div className="btcd-modal-content">
            {hdrActn}
            <button onClick={() => setModal(false)} className="icn-btn btcd-mdl-close" aria-label="modal-close" type="button"><CloseIcn size={16} stroke={3} /></button>
            <h2 className="btcd-mdl-title flx" style={{ color: warning ? 'red' : '' }}>{title}</h2>
            <small className="btcd-mdl-subtitle">{subTitle}</small>
            {!sm && <div className="btcd-mdl-div" />}
            {children}
          </div>
        </div>
      </div>
    </CSSTransition>
  )
}

const CloseIcn = ({ size, stroke = 4, className })=> {
  return (
    <svg id="Icons" className={className} width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><path d="m4.59 59.41a2 2 0 0 0 2.83 0l24.58-24.58 24.59 24.58a2 2 0 0 0 2.83-2.83l-24.59-24.58 24.58-24.59a2 2 0 0 0 -2.83-2.83l-24.58 24.59-24.59-24.58a2 2 0 0 0 -2.82 2.82l24.58 24.59-24.58 24.59a2 2 0 0 0 0 2.82z" /></svg>

  )
}